import type { Platform, ShareContent } from '../types';
import { buildShareUrl } from '../utils/url';
import { PlatformRegistry } from './registry';

export const twitter: Platform = {
  id: 'twitter',
  name: 'X (Twitter)',
  iconIndex: PlatformRegistry.twitter.index,
  color: PlatformRegistry.twitter.color,
  buildUrl: (content: ShareContent): string => {
    return buildShareUrl('https://twitter.com/intent/tweet', {
      text: content.title,
      url: content.url,
      hashtags: content.hashtags,
    });
  },
};

